export default "__VITE_ASSET__Cd2ceeMy__"